import { Tooltip } from "antd";
import React from "react";
import { WarningInfoIcon } from "src/pages/features/WeatherMonitorAntdOnly";

export const Co2Badge = (props: {co2: number | null | undefined}) => {

    const highLevel = 1000;
    if (props.co2 == null) {
        return null;
    }
    const show = props.co2 > highLevel;
    return <span className="co2-warning-badge" style={{visibility: show ? "visible" : "hidden"}}>
        <Tooltip title={`CO2 level is above ${highLevel} ppm`}>
            <WarningInfoIcon />
        </Tooltip>
    </span>
}